module.exports = __webpack_public_path__ + "1touch.adff78559dff5f947cd7.eot";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/1touch.eot
// module id = ../../../../../src/fonts/1touch.eot
// module chunks = 3